import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "10",
  viewBox: "0 0 8 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.98437 1.93262L1.98437 9",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.51562 1.93262L6.51562 9",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }